module.exports = __webpack_public_path__ + "img/aav.698e1560.png";